import { combineReducers } from 'redux'

import filtroAplicados from './filtroAplicados'
import resultados from './despesasPorEmpenho'

export default combineReducers({ filtroAplicados, resultados })
